import { render, staticRenderFns } from "./FirstSubBtn.vue?vue&type=template&id=8a0f1316&scoped=true&"
import script from "./FirstSubBtn.vue?vue&type=script&lang=js&"
export * from "./FirstSubBtn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a0f1316",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
